import React, { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { X } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import { editUser } from "../../actions/ManageUserAction";
import Loading from "../Layout/Loading";
import EntryFormContent from "./EntryFormContent";

const EditUser = ({ closeModal: parentCloseModal, selectedObject }) => {
  const modalRef = useRef(null);
  const [isOpen, setIsOpen] = useState(true);
  const [isMobile, setIsMobile] = useState(false);
  const [formData, setFormData] = useState({
    username: selectedObject.username,
    password: selectedObject.password,
    phone_number: selectedObject.phone_number,
    email: selectedObject.email,
    distributor_name: selectedObject.distributor_name || "",
    GroupName: selectedObject.GroupName || "",
  });
  const [loading, setLoading] = useState(false);
  // Check if the screen is mobile
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768); // FIXME:
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);

    return () => {
      window.removeEventListener("resize", checkMobile);
    };
  }, []);

  const closeModal = () => {
    setIsOpen(false);
    setTimeout(() => {
      parentCloseModal();
    }, 400);
  };
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    if (!formData.productName || !formData.patientName || !formData.date) {
      toast.error("Please fill all required fields.");
      return;
    }

    setLoading(true);
    try {
      const response = await editUser(formData);
      if (response.success) {
        toast.success("Successfully added");
        closeModal();
      } else {
        toast.error("Error occurred");
      }
    } catch (error) {
      toast.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  // Close modal when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        closeModal();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <AnimatePresence>
        {isOpen &&
          (isMobile ? (
            // Mobile dialog (centered, no animation)
            <div
              ref={modalRef}
              className="bg-white w-[85vw] max-w-[800px] rounded-lg max-h-[800px] px-6 shadow-lg h-[85vh]"
            >
              {loading ? (
                <Loading />
              ) : (
                <>
                  <EntryFormContent
                    formData={formData}
                    handleChange={handleChange}
                    handleSubmit={handleSubmit}
                    handleCancel={parentCloseModal}
                    type="Edit"
                  />
                </>
              )}
            </div>
          ) : (
            // Desktop slide-in panel
            <motion.div
              ref={modalRef}
              initial={{ x: "100%" }}
              animate={{ x: 0 }}
              exit={{ x: "100%" }}
              transition={{ type: "tween", duration: 0.4 }}
              className="bg-white w-[70vw] h-full px-6 absolute right-0 top-0 shadow-lg max-w-[900px]"
            >
              {loading ? (
                <Loading />
              ) : (
                <>
                  <button
                    onClick={closeModal}
                    className="absolute top-0 -left-12 bg-gray-200 rounded-md p-1 shadow-md"
                  >
                    <X className="w-7 h-7 text-gray-500 hover:text-gray-800" />
                  </button>
                  <div className="pt-4">
                    <EntryFormContent
                      formData={formData}
                      handleChange={handleChange}
                      handleSubmit={handleSubmit}
                      type="Edit"
                    />
                  </div>
                </>
              )}
            </motion.div>
          ))}
      </AnimatePresence>
    </div>
  );
};

export default EditUser;
